import { render, staticRenderFns } from "./import-from-quote.vue?vue&type=template&id=f54aebb4&scoped=true"
import script from "./import-from-quote.vue?vue&type=script&lang=js"
export * from "./import-from-quote.vue?vue&type=script&lang=js"
import style0 from "./import-from-quote.vue?vue&type=style&index=0&id=f54aebb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f54aebb4",
  null
  
)

export default component.exports